import { useState } from 'react';
import type { ReportePadronEstado, ReportePadronParams } from '@lib/services/reportePadron';
import { OPCIONES_ESTADO_PADRON } from '@lib/estado-reporte-padron';
import {
  BotonBuscar,
  CampoTexto,
  FormFiltros,
  RangoFechas,
  SelectOrganizacion,
} from '@components/FiltrosReporte';

interface FiltrosProps {
  onBuscar: (params: ReportePadronParams) => void;
  loading?: boolean;
}

/**
 * Filtros del Reporte de padrón (VEN-512). Las fechas son las de CARGA de la
 * persona (cuando su legajo entró al portal), no vigencias: el reporte es para
 * seguir los casos cargados.
 */
export function ReportePadronFiltros({ onBuscar, loading }: FiltrosProps) {
  const [estado, setEstado] = useState<ReportePadronEstado | ''>('');
  const [fechaDesde, setFechaDesde] = useState('');
  const [fechaHasta, setFechaHasta] = useState('');
  const [empresaId, setEmpresaId] = useState('');
  const [dni, setDni] = useState('');

  function handleSubmit() {
    onBuscar({
      estado: estado || undefined,
      fechaDesde: fechaDesde || undefined,
      fechaHasta: fechaHasta || undefined,
      empresaId: empresaId || undefined,
      dni: dni || undefined,
    });
  }

  return (
    <FormFiltros onSubmit={handleSubmit}>
      <label className="formField" style={{ maxWidth: 220 }}>
        <span>Estado</span>
        <select
          className="input"
          value={estado}
          onChange={(e) => setEstado(e.target.value as ReportePadronEstado | '')}
        >
          <option value="">— Todos —</option>
          {OPCIONES_ESTADO_PADRON.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
      </label>

      <RangoFechas
        prefijo="Cargado"
        desde={fechaDesde}
        hasta={fechaHasta}
        onDesde={setFechaDesde}
        onHasta={setFechaHasta}
      />
      <SelectOrganizacion value={empresaId} onChange={setEmpresaId} />
      <CampoTexto label="DNI" value={dni} onChange={setDni} />
      <BotonBuscar loading={loading} />
    </FormFiltros>
  );
}
